import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { filter, share, switchMap, takeUntil } from 'rxjs/operators';
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatAutocomplete } from '@angular/material/autocomplete';

@Component({
  selector: 'app-create-item',
  templateUrl: './create-item.component.html',
  styleUrls: ['./create-item.component.scss']
})
export class CreateItemComponent implements OnInit,OnDestroy {
  spin: boolean = false;
  form: FormGroup = new FormGroup({
    autocomplete: new FormControl("", [Validators.required])
  });
  productForm: FormGroup = new FormGroup({
    name: new FormControl("", [Validators.required]),
    title: new FormControl(""),
    imageUrl: new FormControl(""),
    brand: new FormControl(""),
    model: new FormControl(""),
    color: new FormControl(""),
    upc: new FormControl(""),
    weight: new FormControl(""),
    width: new FormControl(""),
    height: new FormControl(""),
    length: new FormControl(""),
    notes: new FormControl(""),
    defaultLocation: new FormControl("")
  });
  vendorItemForm: FormGroup = new FormGroup({
    vendor: new FormControl("", [Validators.required]),
    vendorItemName: new FormControl("", [Validators.required]),
    price: new FormControl(0.00, [Validators.required]),
    caseQty: new FormControl(1, [Validators.required]),
    localstock: new FormControl(0, [Validators.required]),
    caseRoundingSetting: new FormControl("none", [Validators.required]),
    note: new FormControl(""),
  });
  private destroy$ = new Subject<void>();
  title: string;
  isSelected: boolean = false;
  isAddProduct: boolean = false;
  filteredOptions$: Observable<any>;
  filteredProducts$: any;
  selectedItems: any[] = [];
  product: any = {};
  isDisable: boolean = true;
  vendors:  any[] = [];
  isValidVendor: boolean= true;
  startRow:number = 0;
  amountPerPage:number = 10;
  startRowArray:any[]=[];
  vendorId;
  @ViewChild('auto') public scroll!: MatAutocomplete;
  
  constructor(private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CreateItemComponent>,
    private inventoryService: InventoryService,
    private planyardService: PlanyardService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    if(this.data.isAddProduct){
      this.isAddProduct=true;
    }else{
      this.getTypeAheadVendor()
    }
    if(this.data?.Item) this.vendorItemForm.get("vendorItemName").setValue(this.data.Item);
      this.form.get("autocomplete").valueChanges.pipe(
      filter(e => typeof e === 'string'),
      switchMap((value) =>{
        if(value){
          this.startRow=0;
          const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
          if(idx != -1){
            this.startRowArray['startrow_']=0
          }else{
            this.startRowArray['startrow_'] = 0;  
          }
          return this.planyardService.TypeaheadItem(value, this.data.vendorId , 'Item',this.startRow,this.startRow + this.amountPerPage)
        } else{
          let e = [];
          return e;
        }
      }),
      share()
    ).subscribe((e)=>{
      this.filteredProducts$ = e;
      this.startRowArray['startrow_']+= this.amountPerPage;
    });
    
    this.filteredOptions$ = this.vendorItemForm.get("vendor").valueChanges.pipe(
      filter(e => typeof e === 'string'),
      switchMap((value) => this.inventoryService.typeaheadVendor(value)),
      share()
    );

    this.filteredOptions$.pipe(takeUntil(this.destroy$)).subscribe((items) => {
      if (typeof this.vendorItemForm.get("vendor")?.value === "string") {
        this.setVendor(items, this.vendorItemForm.get("vendor")?.value);
      }
    });
  }


  action(e) {
    if (e === "Create & Add" && !this.isAddProduct) {  
      let payload: any ={
        itemId: this.form.value.autocomplete.id,
        vendorId: this.data.vendorId,
        vendorItemName: this.vendorItemForm.value.vendorItemName?.trim(),
        caseQty: this.vendorItemForm.value.caseQty,
        price: this.vendorItemForm.value.price,
        localstock: this.vendorItemForm.value.localstock,
        caseRoundingSetting: this.vendorItemForm.value.caseRoundingSetting,
        note: this.vendorItemForm.value.note
      }
      let apiLink = this.inventoryService.SaveVendorItem(payload);
      this.createItem(apiLink);
    } 
    else if(e === "Create & Add" && this.isAddProduct){
      let payload: any ={
        name: this.productForm.value.name.trim(),
        brand: this.productForm.value.brand,
        title: this.productForm.value.title,
        model: this.productForm.value.model,
        notes: this.productForm.value.notes,
        itemUrl: this.productForm.value.itemUrl,
        imageUrl:this.productForm.value.imageUrl,
        width: Number(this.productForm.value.width),
        height: Number(this.productForm.value.height),
        length: Number(this.productForm.value.length),
        weight: Number(this.productForm.value.weight),
        qtyOnHand: Number(this.productForm.value.qtyOnHand),
        color: this.productForm.value.color,
        defaultLocation: this.productForm.value.defaultLocation,
        upc: this.productForm.value.upc,
        vendorItems: [{
          vendorId:this.data.vendorId ? this.data.vendorId : this.vendorId,
          vendorItemName: this.vendorItemForm.value.vendorItemName?.trim(),
          caseQty: this.vendorItemForm.value.caseQty,
          price: this.vendorItemForm.value.price,
          localstock: this.vendorItemForm.value.localstock,
          caseRoundingSetting: this.vendorItemForm.value.caseRoundingSetting,
        }]
      }
      let apiLink = this.planyardService.SaveItem(payload);
      this.createItem(apiLink);
    }
    else {
      this.dialogRef.close();
    }
  }

  createItem(apiLink){
  this.spin = true;
  this.startRow=0;
  const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
  if(idx != -1){
    this.startRowArray['startrow_']=0
  }else{
    this.startRowArray['startrow_'] = 0;  
  }
  apiLink.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.planyardService.TypeaheadItem(this.vendorItemForm.value.vendorItemName, this.data.vendorId,null,this.startRow,this.startRow + this.amountPerPage).pipe(takeUntil(this.destroy$)).subscribe((result : any[])=>{
      this.spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Vendor item saved successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      this.startRowArray['startrow_']+= this.amountPerPage;
    const item = result.find(res => res.title?.toLowerCase() === this.vendorItemForm.value.vendorItemName?.toLowerCase());
    this.dialogRef.close({...item, qty: this.data.qty,res:result});
  });
    },
    (error)=>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
      this.spin = false;
    });  
  }

  onPaste($event: ClipboardEvent) {
    const pastedText = $event.clipboardData.getData("text");
  }

  displayWith(value) {
    if (value) {
      return value.name;
    }
  }

  createProduct(){
    this.isAddProduct = true;
  }

  updateImage() {
    const value = this.productForm.get("imageUrl").value;

    if (value) {
      this.product.imageUrl = value;
    }
  }

  setVendor(items, name): void {
    const item = items.find(
      (res) => res.name?.toLowerCase() === name?.toLowerCase()
    );
    if (item) {
      this.vendorItemForm.patchValue({ vendor: item }, { emitEvent: false });
      this.isDisable = false;
    }else{
      this.isDisable = true;
    }
    this.vendors = items;
    this.checkVendor();
  }

  selected(event){
    this.isSelected = true;
    if (this.form.value.autocomplete.id) {
      this.selectedItems.push({...this.form.value.autocomplete});
    } else {
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Please select valid vendor item',
              action: 'Dismiss',
              type: 'info',
            },
          }
      );
    }
  }

  clear(){
    this.isSelected = false;
    this.form.get('autocomplete').reset();
    this.selectedItems = [];
  }

  clearControl(){
    this.form.get('autocomplete').reset();
  }

  vendorSelected(event){
    this.isDisable = false;
    this.checkVendor();
  }

  checkVendor(){
    let vendor = this.vendorItemForm.get("vendor").value.name ?  this.vendorItemForm.get("vendor").value.name : this.vendorItemForm.get("vendor").value;
    const item = this.vendors.find(res => res.name?.toLowerCase() === vendor?.toLowerCase());
    if (item) { this.isValidVendor = true
      this.vendorId = item.vendorId;}
    else {this.isValidVendor = false}
  }

  
  loadAllOnScroll(event) {
    if (event.target.scrollTop + event.target.offsetHeight == event.target.scrollHeight) {     
      const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
      if(idx != -1){
        this.startRow=this.startRowArray['startrow_'];
      }else{
        this.startRowArray['startrow_'] = 0; 
        this.startRow=0;
      }
      const value= this.form.get("autocomplete").value;
      this.startRowArray['startrow_']+= this.amountPerPage;
      this.planyardService.TypeaheadItem(value, this.data.vendorId, 'Item',this.startRow,this.startRow + this.amountPerPage).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
       this.filteredProducts$.push(...res);
      });
    }
  }
  registerPanelScrollEvent(element) {
      const panel = element;
     panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
   }

  setScroll(){
    const element= document.getElementById(this.scroll.id);
      if(element){     
        this.registerPanelScrollEvent(element);
      }
    }

    getTypeAheadVendor() {
      this.inventoryService.typeaheadVendor(this.data.name).subscribe((items) => {
        this.vendorItemForm.get('vendor').disable();
        this.setVendor(items, this.data.name);
      });
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.unsubscribe();
    }
}
